var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav"},[_c('div',{staticClass:"nav-l"},[_vm._t("left")],2),_c('div',{staticClass:"nav-r"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }